import {
  FaTachometerAlt, FaUniversity, FaGraduationCap, FaCalendarAlt,
  FaFolderOpen, FaChevronDown, FaLayerGroup, FaClock, FaListAlt,
  FaBookOpen, FaUserTie, FaUserCog, FaUsers, FaIdCard,
  FaUserEdit, FaCog, FaChartBar, FaFileAlt, FaQuestionCircle, FaTable,
  FaClipboardList, FaMoneyBillWave,FaDoorOpen,FaClipboardCheck,FaFilePdf,
  FaUserShield,FaSitemap,FaCashRegister,
} from "react-icons/fa";

export const sidebarConfig = {
  // =====================================================================
  // ADMIN ROLE CONFIGURATION
  // =====================================================================
  admin: {
    dashboard: { path: "/admin/dashboard", icon: FaTachometerAlt, label: "Dashboard", description: "Analytics & insights", color: "#4f46e5" },
    sections: [
      {
        id: "master",
        label: "Master Data",
        icon: FaLayerGroup,
        color: "#4f46e5",
        items: [
          // PHASE 1: Institution Setup
          { path: "/admin/university", icon: FaUniversity, label: "University", description: "University settings" },
          { path: "/admin/college", icon: FaUniversity, label: "College", description: "Manage college information" },
          { path: "/admin/academic-year", icon: FaCalendarAlt, label: "Academic Year", description: "Academic calendar" },
          { path: "/admin/category", icon: FaFolderOpen, label: "Category", description: "Category management" },
          
          // PHASE 2: Academic Structure Setup
          { path: "/admin/degree", icon: FaGraduationCap, label: "Degree", description: "Degree programs" },
          { path: "/admin/discipline", icon: FaUniversity, label: "Discipline", description: "Academic disciplines" },
          { path: "/admin/program", icon: FaBookOpen, label: "Program", description: "Academic programs" },
          { path: "/admin/programme-year", icon: FaListAlt, label: "Programme Year", description: "Program years" },
          { path: "/admin/semster", icon: FaCalendarAlt, label: "Semester", description: "Semester management" },
          
          // PHASE 3: Course & Credit Setup
          { path: "/admin/educoursetype", icon: FaFolderOpen, label: "Course Type", description: "Education course types" },
          { path: "/admin/credit-hours", icon: FaClock, label: "Credit Hours", description: "Credit system" },
          { path: "/admin/component-master", icon: FaFolderOpen, label: "Components", description: "Component master" },
          { path: "/admin/courses", icon: FaBookOpen, label: "Courses", description: "Course catalog" },
          
          // PHASE 4: Department & Staff Setup
          { path: "/admin/department", icon: FaFolderOpen, label: "Department", description: "Department management" },
          { path: "/admin/designation", icon: FaUserTie, label: "Designation", description: "Staff designations" },
          { path: "/admin/staff-type", icon: FaUserCog, label: "Staff Type", description: "Staff categories" },
          
          // PHASE 5: Student Setup
          { path: "/admin/registrationtype", icon: FaUserCog, label: "Registration", description: "Registration types" },
          { path: "/admin/section", icon: FaUsers, label: "Section", description: "Class sections" },
          { path: "/admin/room-master",icon: FaDoorOpen, label: "Room Management",description: "Manage examination rooms" },
          { path: "/admin/role-master", icon: FaUserShield, label: "Role Management", description: "Manage user roles and permissions" },
          ]
      },
      {
        id: "academics",
        label: "Academics",
        icon: FaGraduationCap,
        color: "#059669",
        items: [
          // PHASE 6: Faculty Management
          { path: "/admin/staff-profile", icon: FaUserTie, label: "Staff Profile", description: "Staff management" },
          { path: "/admin/faculty-course-mapping", icon: FaBookOpen, label: "Faculty Course Mapping", description: "Assign courses to faculty" },
          
          // PHASE 7: Student Management
          { path: "/admin/enquiries", icon: FaQuestionCircle, label: "Student Enquiry", description: "Student enquiries"},
          { path: "/admin/student-id-format", icon: FaIdCard, label: "Student ID Format", description: "Configure student IDs" },
          { path: "/admin/studentprofile", icon: FaUserEdit, label: "Student Profile", description: "Student information" },
          { path: "/admin/updatestudentsection", icon: FaUsers, label: "Update Sections", description: "Student section updates" },
        ]
      },
      {
        id: "preExam",
        label: "Pre-Exam",
        icon: FaBookOpen,
        color: "#dc2626",
        items: [
          { path: "/admin/semesterregistration", icon: FaCalendarAlt, label: "Semester Registration", description: "Register for semester" },
          { path: "/admin/examination", icon: FaBookOpen, label: "Examination", description: "Exam management" },
          { path: "/admin/exam-timetable", icon: FaTable, label: "Exam Timetable", description: "Create exam schedules" },
          { path: "/admin/exam-attendance",icon: FaClipboardCheck, label: "Exam Attendance",description: "Create Exam attendance" },
        {  path: "/admin/generate-attendance",icon: FaFilePdf,label: "Generate Attendance",description: "Generate PDF attendance sheets for exams" }
        ]
      },
      {
  id: "fees",
  label: "Fee Management",
  icon: FaMoneyBillWave,
  color: "#0E7490",
  items: [
   {path: "/admin/fee-type",icon: FaMoneyBillWave,label: "Fee Types",description: "Create and manage fee type categories"},
    {path: "/admin/fee-categories", icon: FaMoneyBillWave,  label: "Fee Categories", description: "Manage fee categories by degree and program"},
    {path: "/admin/fee-master",  icon: FaMoneyBillWave,   label: "Fee Master", description: "Manage fee structures by degree and program"}
  ]
},

      {
        id: "reports",
        label: "Reports",
        icon: FaChartBar,
        color: "#7c3aed",
        items: [
          { path: "/admin/student-reports", icon: FaChartBar, label: "Student Reports", description: "Student analytics" },
          { path: "/admin/staff-reports", icon: FaFileAlt, label: "Staff Reports", description: "Staff analytics" },
          { path: "/admin/academic-reports", icon: FaGraduationCap, label: "Academic Reports", description: "Academic performance" },
        ]
      }
    ]
  },

  // =====================================================================
  // STUDENT ROLE CONFIGURATION
  // =====================================================================
  student: {
    sections: [
      {
        id: "studentUg",
        label: "Student UG",
        icon: FaGraduationCap,
        color: "#d97706", // A new color for this section
        items: [
          // The ID '1' is a placeholder; the page logic fetches the actual courses.
          { path: "/student/ug/course-detail/1", icon: FaBookOpen, label: "Course Details", description: "View details of a course" },
        ]
      },
      {
        id: "academics",
        label: "My Academics",
        icon: FaGraduationCap,
        color: "#059669",
        items: [
          { path: "/student/my-courses", icon: FaBookOpen, label: "My Courses", description: "View your registered courses" },
          { path: "/student/my-grades", icon: FaChartBar, label: "View Grades", description: "Check your academic performance" },
          { path: "/student/attendance", icon: FaCalendarAlt, label: "My Attendance", description: "Track your attendance record" },
        ]
      },
      {
        id: "finance",
        label: "Finance",
        icon: FaMoneyBillWave,
        color: "#4f46e5",
        items: [
          { path: "/student/fee-payment", icon: FaMoneyBillWave, label: "Fee Payment", description: "Pay your semester fees" },
          { path: "/student/payment-history", icon: FaClock, label: "Payment History", description: "View past transactions" },
        ]
      },
    ]
  },

  // =====================================================================
  // STAFF / FACULTY ROLE CONFIGURATION
  // =====================================================================
  staff: {
    dashboard: { path: "/staff/dashboard", icon: FaTachometerAlt, label: "Faculty Dashboard", description: "Your courses & students", color: "#0891b2" },
    sections: [
      {
        id: "courseManagement",
        label: "Course Management",
        icon: FaBookOpen,
        color: "#0891b2",
        items: [
          { path: "/staff/my-courses", icon: FaBookOpen, label: "My Courses", description: "View your assigned courses" },
          { path: "/staff/manage-grades", icon: FaClipboardList, label: "Manage Grades", description: "Enter and update student grades" },
          { path: "/staff/manage-attendance", icon: FaCalendarAlt, label: "Manage Attendance", description: "Record student attendance" },
          { path: "/staff/timetable", icon: FaCalendarAlt, label: "View Timetable", description: "Check your weekly schedule" },
        ]
      },
      {
        id: "studentInfo",
        label: "Student Information",
        icon: FaUsers,
        color: "#059669",
        items: [
          { path: "/staff/student-list", icon: FaUsers, label: "Student List", description: "View students in your courses" },
        ]
      },
    ]
  },
};